// export const api = "http://localhost:5253";
export const api = "https://travel-booking-app-backend.onrender.com";
